import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'
import { Icon, Popover } from '@manychat/manyui'

import cm from './ValidationErrors.module.css'

const MOUSE_EVENTS_DELAY = 200

export default class ValidationErrors extends React.Component {
  static propTypes = {
    show: PropTypes.bool,
    elementId: PropTypes.string,
    errors: PropTypes.array,
    onShow: PropTypes.func,
    onHide: PropTypes.func,
    renderErrorMessage: PropTypes.func,
  }

  static defaultProps = {
    errors: [],
    onShow: () => {},
    onHide: () => {},
    renderErrorMessage: (err) => `– ${err.message}`,
  }

  componentWillUnmount() {
    clearTimeout(this.mouseTimer)
  }

  handleMouseEnter = (e) => {
    clearTimeout(this.mouseTimer)

    this.mouseTimer = setTimeout(() => {
      const { elementId, errors } = this.props
      this.props.onShow([elementId, ...this._getInnerErrorsElementsIds(errors)])
    }, MOUSE_EVENTS_DELAY)
  }

  handleMouseLeave = (e) => {
    clearTimeout(this.mouseTimer)

    this.mouseTimer = setTimeout(() => {
      this.props.onHide()
    }, MOUSE_EVENTS_DELAY)
  }

  _getInnerErrorsElementsIds = (errors, res) => {
    res = res || []
    for (let err of errors) {
      if (err.type === 'inner') {
        res.push(err.element.id)
        this._getInnerErrorsElementsIds(err.errors, res)
      }
    }
    return res
  }

  renderLayer(errors) {
    return (
      <ul className={cm.list}>
        {errors.map((err, i) => {
          return (
            <li key={i}>
              {err.type !== 'inner' ? (
                this.props.renderErrorMessage(err)
              ) : (
                <>
                  <b>{err.element.label}</b>
                  <div>{this.renderLayer(err.errors)}</div>
                </>
              )}
            </li>
          )
        })}
      </ul>
    )
  }

  rootRef = React.createRef()

  render() {
    const { errors, show, className, style } = this.props
    if (errors.length === 0) {
      return null
    }

    return (
      <div
        className={cx(cm.wrapper, className)}
        style={style}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
        ref={this.rootRef}
      >
        <Icon.Warning size={20} />
        <Popover
          open={show}
          anchor={this.rootRef.current}
          anchorOrigin={'right bottom'}
          targetOrigin={'left bottom'}
          onMouseEnter={this.handleMouseEnter}
          onMouseLeave={this.handleMouseLeave}
          disableDefaultStyle
          useLayerForClickAway={false}
          className={cm.popoverRoot}
        >
          <div className={cx(cm.popover, 'p-a-xs')}>{this.renderLayer(errors)}</div>
        </Popover>
        <Popover
          open={show}
          anchor={this.rootRef.current}
          anchorOrigin={'right center'}
          targetOrigin={'left center'}
          onMouseEnter={this.handleMouseEnter}
          onMouseLeave={this.handleMouseLeave}
          disableDefaultStyle={true}
          useLayerForClickAway={false}
        >
          <div className={cm.popoverArrow} />
        </Popover>
      </div>
    )
  }
}
